export default __webpack_public_path__ + "static/media/create-quote.eacd9b44.png";